<template>
    <footer class="footer bg-dark p-3">
      <small>
        <b-nav>
            <b-nav-item>
                <span class="text-secondary">{{ title }}</span>
            </b-nav-item>
            <b-nav-item class="ml-auto">
              <span class="text-secondary">&copy; ГОБУ ЦИТ МО, {{ currentYear }}</span>
            </b-nav-item>
        </b-nav>
      </small>
    </footer>
</template>
<script lang="js">

  export default {
      data() {
          return {
              title: ''
          }
      },
      computed: {
          currentYear: function () {
              return new Date().getFullYear();
          }
      },
      mounted() {
          this.title = process.env.VUE_APP_TITLE;
      }
  };
</script>
<style>
</style>
